module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAFCAYAAACJmvbYAAAAbElEQVQYV2NkgIIzZ86wcnNzh379+nW1iYnJb5AwI0zyxo0bLQwMDNUMDAytGhoaNXDJGzdu+DMwMGyAKWRgYAjQ0NDYyHjnzh2VP3/+nGJgYBBEknzPwsJixnjz5s3W////5yNJgJmMjIwTAZfJIM5eWMxEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/triangle.png
// module id = 7zg/
// module chunks = 165